export const URL_PREFIX = {
  HTTPS: "https://",
};
